import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { MHCListHeader } from './components/header/MHCListHeader'
import { KTCard } from '../../../../_metronic/helpers'
import { Horizontal } from './components/horizontal-stepper/Horizontal'
import { ShifaImplementationUpdateModal } from './shifa-update-modal/ShifaImplementationUpdateModal'

const ChecklistList = () => {
  const { itemIdForUpdate } = useListView()
  console.log('ChecklistList - itemIdForUpdate:', itemIdForUpdate)
  return (
    <>
      <KTCard>
        <MHCListHeader />
        <Horizontal />
        {itemIdForUpdate !== undefined && <ShifaImplementationUpdateModal />}
      </KTCard>

    </>
  )
}

const MHCListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ChecklistList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { MHCListWrapper }
